<template>
	<div class="service-header">
		<div class="service-header-inner">
			<div class="tab-wrap">
				<van-tabs v-model:active="filter.type" @change="onChange">
          <van-tab title="全部" />
					<van-tab title="收藏" />
				</van-tabs>
			</div>
			<!--<div v-else class="input-box">-->
			<!--	<input-->
			<!--		v-model="filter.keyWords"-->
			<!--		type="text"-->
			<!--		placeholder="搜索微服务"-->
			<!--		@keydown.enter="onChange"-->
			<!--	/>-->
			<!--	<img-->
			<!--		@click="onChange"-->
			<!--		class="search-img"-->
			<!--		src="@/assets/images/information/info_search.png"-->
			<!--	/>-->
			<!--</div>-->
			<div class="operate-wrap" v-if="filter.type === 0">
				<img @click="toSearch" src="@/assets/img/search-black.png" alt="" />
				<img src="@/assets/img/filter-black.png" alt="" @click="showCate = !showCate" />
			</div>
		</div>
		<van-overlay :show="showCate" duration="0.1" z-index="2" @click="showCate = false">
			<div class="service-cate-panel" @click.stop>
				<div class="item-wrap">
					<div
						class="item"
						:class="{ 'item-active': filter.cateStrList.includes(v.name) }"
						v-for="(v, k) in serviceList"
						@click="selectItem(v)"
						:key="k"
					>
						{{ dealName(v.name) }}
					</div>
				</div>
			</div>
		</van-overlay>
	</div>
</template>

<script setup lang="ts">
import { cloneDeep } from 'lodash'
import { useAuthStore } from '@/store/auth'
import { appServiceMenuAPI } from '@/api'

const props = defineProps<{
	value?: any
}>()
const emit = defineEmits(['update:value'])
const filter = ref({})
const showCate = ref(false)
const router = useRouter()
const serviceList = ref([])

watchEffect(() => {
	if (props.value) {
		filter.value = cloneDeep(props.value)
	}
})

onMounted(() => {
	fetchList()
})
const onChange = () => {
	emit('update:value', filter.value)
}

const dealName = (fullName = '') => {
	return fullName.slice(0, 2) + '微服'
}

const selectItem = (v) => {
	const index = filter.value.cateStrList.findIndex((_v) => _v === v.name)
	if (index >= 0) {
		filter.value.cateStrList.splice(index, 1)
	} else {
		filter.value.cateStrList.push(v.name)
	}
	onChange()
}

const toSearch = () => {
	router.push({
		path: '/layout/service-search'
	})
}

const fetchList = async () => {
	try {
		const userStore = useAuthStore()
		try {
			const res = await appServiceMenuAPI({
				userName: userStore.userInfo.F_UserId,
				tenantId: '1a1cb2b893d34fcea1d041681f6c9586'
			})
			const resData = res.data || {}
			serviceList.value = resData.list || []
		} catch (e) {
			console.log(e)
		}
	} catch (e) {
		console.log(e)
	}
}
</script>

<style lang="scss">
.service-header {
	.van-tabs__line {
		width: 20px;
	}
}
</style>
<style scoped lang="scss">
.service-header {
	position: relative;
	width: 100%;
	height: 60px;
	.service-header-inner {
		position: fixed;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
		background: #ffffff;
		box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
		z-index: 3;
	}
	.service-cate-panel {
		position: absolute;
		width: 100%;
		top: 128px;
		left: 0;
		padding: 15px;
		box-sizing: border-box;
		background: #ffffff;
		border-radius: 0px 0px 10px 10px;
		.item-wrap {
			display: flex;
			flex-wrap: wrap;
			column-gap: 10px;
			.item {
				padding: 10px 14px;
				flex-shrink: 0;
				background: #f8f7f7;
				border-radius: 45px;
				margin-bottom: 10px;
				font-weight: 400;
				font-size: $miniFontSize;
				color: #7d7e80;
				line-height: 14px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.item-active {
				background: rgba(189, 58, 54, 0.1);
				color: $primaryColor;
			}
		}
	}
	.tab-wrap {
		width: 120px;
	}
	.search {
		width: 100%;
		padding: 0 !important;
	}
	.operate-wrap {
		display: flex;
		align-items: center;
		> img {
			width: 20px;
			margin-left: 10px;
		}
	}

	.input-box {
		width: 100%;
		margin: 0 auto;
		height: 34px;
		background-color: #fff;
		border-radius: 17px;
		display: flex;
		align-items: center;
		padding: 0 18px 0 12px;
		box-sizing: border-box;
		border: 1px solid #e4e5e7;
		input {
			font-size: 12px;
			background-color: transparent;
			border: none;
			flex: 1;
			&::placeholder {
				color: #7d7e80;
			}
		}
		.search-img {
			width: 16px;
		}
	}
}
</style>
